import { makeStyles } from '@material-ui/core/styles'
import { Button, Checkbox, FormControlLabel, Zoom } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { useHistory } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip'
import {
  addToCompareList,
  removeFromCompareList,
  showNotificationMessage,
  updateMemberDetails,
  updatePlanDetailsQuote,
  updateProviderDetails,
  updateSelectedQuote,
} from 'src/actions'
import { useDispatch, useSelector } from 'react-redux'
import React, { useState } from 'react'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  fetchTokenForBuyPolicy,
  getProviderDetails,
  saveISNPStatus,
} from 'src/services/buyPolicyService'
import RightArrow from 'src/assets/Buy_Policy_Images/RightArrow.svg'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  INSURANCE_TYPE_CATOGORIES,
} from 'src/utils/constants/BuyPolicy'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import { getTokenForQrReport } from 'src/services/individualService'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const InsuranceTile = ({ insuranceDetails }) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const coverages = insuranceDetails?.baseCoverages?.slice(0, 5)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [loading, setLoading] = useState(false)

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchProviderDetails(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchProviderDetails = async (token) => {
    setLoading(true)

    const response = await getProviderDetails(
      token,
      insuranceDetails.providerId
    )
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        dispatch(updateProviderDetails(responseData?.data))
        dispatchAndRedirect()
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const saveMetadataAndNavigate = (redirectPath) => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token, redirectPath)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      })
  }

  const saveISNPStatusTasks = async (token, redirectPath) => {
    setLoading(true)
    const formData = getISNPStatusRequestBody(
      guestUserDetails,
      INSURANCE_TYPE_CATOGORIES?.health,
      CURRENT_STATUS?.quickQuoteReceived
    )
    saveISNPStatus(token, formData)
      .then((response) => {
        return response?.res?.data
      })
      .then(() => {
        setLoading(false)
        history.push(redirectPath)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      })
  }

  const dispatchAndRedirect = () => {
    dispatch(updateSelectedQuote(insuranceDetails))
    const redirectPath =
      '/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
    saveMetadataAndNavigate(redirectPath)
  }

  const handleBuy = () => {
    if (
      guestUserDetails?.selectedQuote?.enquiryId !== insuranceDetails?.enquiryId
    ) {
      const memberDetailsList = guestUserDetails?.memberDetails
      memberDetailsList?.forEach((member) => {
        member.medicalQuestionnaire = null
      })
      dispatch(updateMemberDetails(memberDetailsList))
      fetchToken()
    } else {
      dispatchAndRedirect()
    }
  }

  const getCoverageToolTip = (coverage) => {
    return (
      <div className={classes.tooltipContainer}>
        <span>{coverage?.coverName}</span>
        {coverage?.coverMeaning && (
          <span>
            <b>Description :</b>&nbsp;{coverage?.coverMeaning}
          </span>
        )}
      </div>
    )
  }

  const handleViewPlanDetails = () => {
    dispatch(updateSelectedQuote(insuranceDetails))
    dispatch(updatePlanDetailsQuote(insuranceDetails))
    const redirectPath =
      '/individual/dashboard/buyPolicy/health/insuranceDetails/plan-details'
    saveMetadataAndNavigate(redirectPath)
  }

  const handleAddToCompare = () => {
    if (isInsuranceAddedToCompare()) {
      dispatch(removeFromCompareList(insuranceDetails))
    } else {
      dispatch(addToCompareList(insuranceDetails))
    }
  }

  const isInsuranceAddedToCompare = () => {
    const compareList = guestUserDetails?.comparePlanList
    const index = compareList?.findIndex(
      (listItem) => listItem?.enquiryId === insuranceDetails?.enquiryId
    )

    return index !== -1
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.tileBackgroundContainer}>
        <div className={classes.tileContainer}>
          <div className={classes.providerImageContainer}>
            <img src={insuranceDetails?.providerImage} alt={'Provider'} />
          </div>
          <div className={classes.detailsContainer}>
            <div className={classes.providerDetailsContainer}>
              <div className={classes.providerDetails}>
                <span className={classes.providerName}>
                  {insuranceDetails?.providerName}
                </span>
                <span className={classes.insuranceName}>
                  {insuranceDetails?.insuranceName}
                </span>
              </div>
              <div className={classes.pricingDetails}>
                <div className={classes.coverDetails}>
                  <span className={classes.coverDetailsTitle}>
                    Cover Amount
                  </span>
                  <span className={classes.coverAmount}>
                    {formatToINR(insuranceDetails?.sumInsured)}
                  </span>
                </div>
                <div className={classes.priceDetails}>
                  <div className={'flex-row'}>
                    <span className={classes.coverDetailsTitle}>
                      Price:&nbsp;&nbsp;
                    </span>
                    <span className={classes.price}>
                      {insuranceDetails?.premiumAmount !== null
                        ? formatToINR(insuranceDetails?.premiumAmount)
                        : '-'}
                    </span>
                  </div>
                  <span className={classes.coverDetailsTitle}>
                    As low as&nbsp;
                    <span className={classes.coverDetailsTitleAmount}>
                      {insuranceDetails?.premiumAmount !== null
                        ? formatToINR(insuranceDetails?.premiumAmount / 365)
                        : '-'}
                      /-&nbsp;
                    </span>
                    per day
                  </span>
                </div>
              </div>
            </div>

            <div className={classes.coveragesContainer}>
              {coverages?.map((coverage) => {
                return (
                  <Tooltip
                    TransitionComponent={Zoom}
                    placement='top'
                    title={getCoverageToolTip(coverage)}
                    arrow
                    key={`coverage_${coverage?.masterCoverId}`}
                  >
                    <div className={classes.coverageItem}>
                      {coverage?.coverName}
                    </div>
                  </Tooltip>
                )
              })}
            </div>

            <div className={classes.actionContainer}>
              <div className={classes.addToCompareContainer}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isInsuranceAddedToCompare()}
                      onChange={handleAddToCompare}
                    />
                  }
                  label='Add To Compare'
                  className={classes.checkboxformat}
                />
              </div>

              <div className={'flex-row gap-10'}>
                <div
                  className={classes.viewPlanDetailsContainer}
                  onClick={handleViewPlanDetails}
                >
                  <span className={classes.viewPlanDetailsText}>
                    View Plan Details
                  </span>
                  <img
                    src={RightArrow}
                    alt={'Plan Details'}
                    className={classes.viewPlanDetailsImage}
                  />
                </div>
                <div className={classes.buyContainer}>
                  <Button
                    id='buyButton'
                    variant={'contained'}
                    className={classes.buyButton}
                    onClick={handleBuy}
                  >
                    Buy
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default InsuranceTile

export const useStyles = makeStyles({
  tileBackgroundContainer: {
    background: 'linear-gradient(180deg, #B6D1D9 0%, #FFFFFF 100%)',
    padding: '1px',
    borderRadius: '11px',
  },
  tileContainer: {
    boxShadow: '0px 8px 8px 0px #0000001A',
    display: 'flex',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
  },
  providerImageContainer: {
    width: '18%',
    background:
      'linear-gradient(360deg, #F3F3F3 0%, rgba(243, 243, 243, 0) 122.3%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px 0 0 10px',
  },
  detailsContainer: {
    width: '82%',
    padding: '10px 20px',
    borderRadius: '0 10px 10px 0',
  },
  providerDetailsContainer: {
    padding: '10px 0px',
    borderBottom: '1px solid #D1D1D1',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  providerDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  checkboxformat: {
    '& .MuiFormControlLabel-label': {
      fontSize: '11px',
      color: '#2695B4',
    },
  },
  providerName: {
    fontSize: '10px',
    fontWeight: 400,
    color: '#666666',
  },
  insuranceName: {
    fontSize: '17px',
    fontWeight: 600,
    color: '#2BA6C8',
  },
  pricingDetails: {
    display: 'flex',
    flexDirection: 'row',
    gap: '40px',
  },
  coverDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  coverDetailsTitle: {
    fontSize: '11px',
    fontWeight: 400,
    color: '#666666',
  },
  coverAmount: {
    fontSize: '15px',
    fontWeight: 600,
  },
  priceDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'right',
    alignItems: 'flex-end',
    gap: '5px',
  },
  price: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#2BA6C8',
  },
  coveragesContainer: {
    padding: '10px 0px',
    borderBottom: '1px solid #D1D1D1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  coverageItem: {
    fontSize: '11px',
    borderRight: '1px solid #CACACA',
    flex: '1',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:first-child': {
      paddingLeft: 'unset',
    },
    '&:last-child': {
      border: 0,
      paddingRight: 'unset',
    },
  },
  actionContainer: {
    padding: '10px 0px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  addToCompareContainer: {},
  viewPlanDetailsContainer: {
    display: 'flex',
    gap: '5px',
    color: '#2695B4',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  viewPlanDetailsText: {
    fontSize: '12px',
  },
  viewPlanDetailsImage: {
    height: '10px',
    width: '10px',
  },
  buyContainer: {},
  buyButton: {
    background: 'linear-gradient(226.67deg, #73CFEE 34.4%, #5DB2C9 123.77%)',
    color: COLORS.WHITE,
    width: '100px',
    height: '30px',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
  },
  tooltipContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  coverDetailsTitleAmount: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#000000',
  },
})
